import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontSourceSerif4, styleToggle, theme } from "shared/lib/styles";

import { Loading } from "scmp-app/components/common/loading";

import { HomeV2Timelines } from "./timelines";

export const Container = styled.div<{ $hasLabel?: boolean }>`
  display: grid;

  ${({ $hasLabel = false }) => css`
    grid-template-areas:
      ${styleToggle($hasLabel, '"label"')}
      "primary-article-image-carousel"
      "primary-article"
      "time-line";
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;

    ${theme.breakpoints.up("tablet")} {
      grid-template-areas:
        ${styleToggle($hasLabel, '"label label"')}
        "primary-article primary-article"
        "time-line primary-article-image-carousel";
      grid-template-columns: 280px minmax(0, 1fr);
      gap: 24px;
    }
    ${theme.breakpoints.up("desktop")} {
      grid-template-areas:
        ${styleToggle($hasLabel, '"label label label"')}
        "primary-article time-line primary-article-image-carousel";
      grid-template-columns: 340px 280px minmax(0, 1fr);

      padding-block-end: 6px;
    }
  `}
`;

export const Label = styled.div`
  grid-area: label;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 110%;
  letter-spacing: -4%;
  overflow-wrap: break-word;

  ${theme.breakpoints.up("tablet")} {
    font-size: 32px;
  }
  ${theme.breakpoints.up("desktop")} {
    font-size: 40px;
  }
`;

export const TimelineContainer = styled.div`
  grid-area: time-line;

  display: flex;

  ${theme.breakpoints.up("desktop")} {
    margin-inline-start: 4px;
  }
`;

export const StyledLoading = styled(Loading)``;

export const StyledHomeV2Timelines = styled(HomeV2Timelines)`
  border-inline-start: 1px dashed #979797;

  ${theme.breakpoints.up("desktop")} {
    border-inline-start: 1px dashed #5a5a5a;
  }
`;
